/* eslint-disable import/no-unresolved */
import 'javascripts/portal_used_model_v2/about_us';
import 'stylesheets/portal_used_model_v2/about_us';
